import { UserProfile } from "./types";
import appClient from "../../common/services/AppClient";
import { ResponseData } from "../../common/services/AppClient";
import { UserModel } from "../types/UserModel";
import { endpoints } from "../../../config";

export default class UserProfileService {
    async getUserProfile() {
        const url = `${endpoints.tasksUrl}userProfile/current-user`;
        return appClient.get<UserProfile>(url);
    }

    updateUserProfile(data: FormData) {
        const url = endpoints.tasksUrl + "userProfile";
        return appClient.post(url, data);
    }

    async getAvatarIcon(userId: string) {
        const url = `${endpoints.tasksUrl}userProfile/icon/${userId}`;
        return appClient.get<Blob | undefined>(url, "blob");
    }

    getUserByName(name: string) {
        const url = `${endpoints.tasksUrl}users/${name}`;
        return appClient.get<UserModel>(url);
    }

    resetPassword(password: string) {
        const data = { password };
        const url = endpoints.tasksUrl + "userProfile/password";
        return appClient.post<boolean>(url, data);
    }

    async changePassword(
        newPassword: string,
        oldPassword: string,
    ): Promise<ResponseData> {
        const data = { oldPassword, newPassword };
        const url = endpoints.tasksUrl + "userProfile/password_change";
        return appClient.postRaw(url, data);
    }
}
